import React from "react";
import { Link, useLocation, withRouter } from "react-router-dom";
import * as RoutePath from "../../shared/utils/routeLink";
import * as Variable from "../../shared/utils/variables";
import { connect } from "react-redux";
import "./Header.scss";

const SecondaryHeader = ({ ENV_NAME, ...props }) => {
	const location = useLocation();

	// It's active if it's part of one of the array
	const checkActiveOn = (pathname, arr) => {
		return arr?.some((i) => pathname?.includes(i));
	};

	return (
		<nav className="secondary-header-nav">
			<div className="link-container container d-flex align-items-center">
				<Link
					to={RoutePath.COLLEGE}
					className={`nav-menu ${
						checkActiveOn(location.pathname, [RoutePath.COLLEGE, RoutePath.COLLEGE_DETAIL]) ? "active" : ""
					}`}
				>
					{Variable.COLLEGE[ENV_NAME]}
				</Link>
				<Link
					to={RoutePath.MAJOR}
					className={`nav-menu ${
						checkActiveOn(location.pathname, [RoutePath.MAJOR, RoutePath.MAJOR_DETAIL]) ? "active" : ""
					}`}
				>
					{Variable.MAJOR[ENV_NAME]}
				</Link>
				<Link
					to={RoutePath.SCHOLARSHIP}
					className={`nav-menu ${
						checkActiveOn(location.pathname, [RoutePath.SCHOLARSHIP, RoutePath.SCHOLARSHIP_DETAIL])
							? "active"
							: ""
					}`}
				>
					{Variable.SCHOLARSHIP[ENV_NAME]}
				</Link>
				<Link
					to={RoutePath.CAREER}
					className={`nav-menu ${
						checkActiveOn(location.pathname, [RoutePath.CAREER, RoutePath.CAREER_DETAIL]) ? "active" : ""
					}`}
				>
					{Variable.CAREER[ENV_NAME]}
				</Link>
			</div>
		</nav>
	);
};

const mapStateToProps = (state) => {
	return { ...state, ENV_NAME: state.auth.selectedEnvironment || "bhs" };
};

const mapDispatchToProps = (dispatch) => {
	return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SecondaryHeader));
